import Media from '@Components/Plugins/MediaControl';
import translator from '@Components/Utilities/Translator';
import { useEffect } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const MediaControl = (props) => {
    const windowSize = useWindowSize();

    useEffect(() => {
        if (document.readyState !== 'loading') {
            mediaControl('media-control');
        }
        else {
            document.addEventListener('DOMContentLoaded', () => {
                mediaControl('media-control');
            });
        }
    }, [windowSize.isMobile]);

    return (
        <Media
            {...props}
            allText={translator.translate('sandhills.all')}
            threeSixtyText={translator.translate('sandhills.360photos')}
            photosText={translator.translate('sandhills.photos')}
            videosText={translator.translate('sandhills.videos')}
        />
    );
};

export default MediaControl;